// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .AddPayoutContainer-container-Sjj6A {
 	margin: 5px auto;
 	padding: 0 0 40px;
 	margin-top: 30px;
 	max-width: var(--max-content-width);
 }

 .AddPayoutContainer-landingContainer-KEpLC {
 	max-width: 1080px;
 	width: 100%;
 	display: block;
 	margin: 0 auto;
 }`, "",{"version":3,"sources":["webpack://./src/routes/addPayout/AddPayoutContainer.css"],"names":[],"mappings":"CAAC;EACC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;CACpC;;CAEA;EACC,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,cAAc;CACf","sourcesContent":[" .container {\n \tmargin: 5px auto;\n \tpadding: 0 0 40px;\n \tmargin-top: 30px;\n \tmax-width: var(--max-content-width);\n }\n\n .landingContainer {\n \tmax-width: 1080px;\n \twidth: 100%;\n \tdisplay: block;\n \tmargin: 0 auto;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddPayoutContainer-container-Sjj6A`,
	"landingContainer": `AddPayoutContainer-landingContainer-KEpLC`
};
module.exports = ___CSS_LOADER_EXPORT___;
